import React, {useState} from 'react';

export default function Random() {
  const [thought, setThought] = useState('');
  console.log('Random', thought);

  function random_toggle(t) {
    console.log('random_toggle', t);
    if (t===thought) t = '';
    setThought(t);
    console.log('thought', thought);
  }

  return (
    <div className='w-full h-full'>
      <div className='w-full text-center text-2xl bg-slate-600'>
        Random Thoughts
      </div>
      <div id='Random' className='h-full bg-slate-400'>
        <div className='RandomTitle' onClick={()=>random_toggle('simple')}>
          Simple Faith
        </div>
        { thought==='simple' && 
        <div id='simple' className='RandomThought'>
          Faith—simple faith—O that I were blesssed with simple faith. Not the
          complicated faith that is always qestioning, always searching, for
          that elusive feeling that I am doing proper service to God in Christ.
          Though the bliss of simple faith beacons me to the peace of Christ, my
          love of Christ bids me to suffer the tribulations of service. O that
          He will grant me the satisfaction of service so that I may bear the
          sorrows of love.
        </div>
        }
        <div className='RandomTitle' onClick={()=>random_toggle('clouds')}>
          Clouds
        </div>
        { thought==='clouds' && 
        <div id='clouds' className='RandomThought'>
          At 30,000 feet, flying from Burbank to Dallas, I looked out the window
          of the airplane onto some of the most stunning and unusually beautiful
          clouds that I have ever seen. What made them unusual was not their
          size—they weren’t large, powerful thunderheads or the frail, wispy
          streaks of cirrus—they were the kind that you see often after the
          passing of a storm. The fluffy, puffy kind that sort of look like
          sheep wandering through the sky. Except these were in a way very
          different. They looked as if someone had taken a black felt marker and
          outlined and shaded the tips of each of the billows. As if someone had
          sifted black soot over the tops of icebergs. Had I seen this depicted
          by an artist I would have thought that the artist was trying to
          express the synthesis of allayment and yet sullenness that often comes
          after a storm. But it wasn’t an artist’s canvas that I saw. It was a
          picture painted on the sky by God. A picture perhaps expressing the
          emotions that we feel after we have persevered through some trial or
          temptation. A picture of unspeakable peace. God portrays himself to us
          in wondrous ways.
        </div>
        }
        <div className='RandomTitle' onClick={()=>random_toggle('debate')}>
          Debate!
        </div>
        { thought==='debate' &&
        <div id='debate' className='RandomThought'>
          Debate! Faith versus reason! How is it that some are rescued by faith
          while others succumb to reason? Faith is beyond reason—but reason
          cannot overcome itself. Reason is the unbroken circle of
          self—unrecognized as self in its reasoning. How can the circle be
          broken? What can cause the leap from reason to faith? Certainly not
          more reason. What power can possibly bring faith to one inexorably
          trapped within reason? The answer is faith itself! Faith not rising
          from within reason where it suffocates, but faith from without, where
          it breathes. The only possibility of resuscitating faith from the
          stranglehold of reason is the life-giving breath of faith from Christ
          through the Spirit. Through faith all things are possible, even
          bringing forth faith out of the bond of reason.
        </div>
        }
        <div className='RandomTitle' onClick={()=>random_toggle('fallen')}>
          In the Fallen Land
        </div>
        { thought==='fallen' &&
        <div id='fallen' className='RandomThought'>
          So here I am—sitting at the nearly empty bar in the New Orleans
          Sheraton, watching the families attending the Southern Baptist Pastors
          Convention walk to and fro in the lobby. I think, somewhat chidingly,
          about their questionably strict prohibitions against smoking and
          drinking and dancing. Most of them are oblivious to me, but some cast
          a mildly condescending gaze my way, and some of the kids peer
          curiously toward the bar. They seem to me like a tribe of
          innocents—wandering in a fallen land.
          <br />
          <br />
          We are told to be in the world but not of the world. But to what
          degree? I don’t smoke—it seems like a waste. I don’t dance—often. I do
          drink—some. I like the taste of beer and scotch (single malt, of
          course), and cabernet sauvignon. I don’t particularly care for sodas.
          But I especially hate hangovers. It’s kind of a cruel twist that what
          I like to drink has alcohol in it. I drink because of the flavors, not
          the consequences. My doctor once told me that a beer a day was good
          for me. I guess that a six-pack probably isn’t. All things in
          moderation—unfortunately.
          <br />
          <br />
          But what about the Baptists? For them—some things not at all—not even
          in moderation. Is that the higher stand? Or does it open the door to
          temptation—a curiosity of things not tasted? Does moderation reduce
          the risk of overconsumption? Or does a taste lead to overindulgence? I
          suppose to each his own. We must each decide the degree to which we
          are to be in the world while remaining uncorrupted by the world. If we
          are not in the world to some extent, how can we minister to those who
          are fully engaged? Some may rightly consider it justified to make it
          through life untouched and unsullied by contact. But is it not more
          justifiable to risk temptation, to risk even falling, to reach those
          mired in the depths of worldly desires? We can only pray that we will
          not only be led not into temptation, but that we can help others be
          delivered from evil.
        </div>
}
        <div className='RandomTitle' onClick={()=>random_toggle('bow')}>
          The Bow
        </div>
        { thought==='bow' &&
        <div id='bow' className='RandomThought'>
          A ship plows its way upriver against the current. At its bow, the
          waters froth and tremble, eventually dividing and calming along one
          side of the ship or the other. Is this a metaphor for the lives of
          some people? Drifting lazily through life, like the river flowing down
          to its end at the sea. Tending toward neither the left bank nor the
          right, but opting for the non-committal center. Then suddenly there is
          intrusion—disturbing the calm flow. We flail and churn, finally
          committed to either the right bank of faith or the left bank of
          despair. The wake forces us firmly against that bank where we tend to
          stay. Sometimes when the stern passes by, we are sucked back into
          midstream, but rarely. O Lord, guide us with your love to the right
          bank before we are hit with the bow of tribulation.
        </div>
}
        <div className='RandomTitle' onClick={()=>random_toggle('commitment')}>
          Commitment
        </div>
        { thought==='commitment' &&
        <div id='commitment' className='RandomThought'>
          There comes a point, taxiing down the runway on the way to takeoff,
          when the pilot must make an extremely critical decision. This is the
          commitment point—sometimes called the point of no return. The point
          beyond which the takeoff cannot be aborted. The point, once passed,
          which cannot be revisited. The point when the pilot musters all of his
          courage, recalls all of this training, and relies on all of his
          experience to make a decision—a decision to commit to the takeoff, or
          abort.
          <br />
          <br />
          If his courage falters, if his training detects a flaw, if his
          experience warns him off, he aborts the takeoff. He returns to the
          terminal—perhaps to try again some time later. But, if his courage,
          his training, and his experience bring him promise, he makes the
          commitment to leap to the heavens. Yet this is more than a
          commitment—this is faith— for this is a life-threatening commitment—an
          irreversible decision.
          <br />
          <br />
          In our lives we too may also reach a point of commitment—a point
          beyond which there is no return. A point when we too are called upon
          to make a leap of faith. The circumstances are similar. We call upon
          our courage, our training, and our experience to tell us whether to
          leap, or to stand fast. But there is also a difference. Unlike the
          pilot whose desire is for the heavens, our desire is for the earth,
          the tangible, the touchable security of reality and reason. The call
          we hear threatens our security. For the leap we are called to make is
          also to the heavens, the intangible, the untouchable—beyond reason and
          reality.
          <br />
          <br />
          The call is strong—but our courage is weak. The call is clear—but our
          training fogs our vision. The call is secure—but our experience warns
          us off. We return to the terminal, which for us is actually a
          terminus, for earthly life leads to a dead end. An end at which the
          possibilities of what could have been are forfeit. It is then that we
          learn who called us. But it is too late. We learn that because we
          lacked faith, because we failed to pass the point of no return, we
          missed the call to true life. We missed the call of Christ. The call
          to be with Him in Heaven.
        </div>
}
        <div className='RandomTitle' onClick={()=>random_toggle('famous')}>
          Anonymously Famous
        </div>
        { thought==='famous' &&
        <div id='famous' className='RandomThought'>
          As I sit here reading yet another book, desperately continuing to
          search You out God, I read about the many who are “famous” in their
          service to You. While I attempt to live a life pleasing and worthy of
          You, I have a twinge of jealousy in my heart because I too want to be
          that kind of faithful servant – famously faithful. I also fear that
          fame, that it is an end in itself, a desire leading to destruction.
          But, my yearn to do Your will is consuming so, somehow, I must not
          care if anyone but You know that I serve You well. All I can do is
          pray that I have the faith to endeavor to serve well, to pray that I
          am serving well, and hope that I may be anonymously famous, even to
          myself.
        </div>
}
        <div className='RandomTitle' onClick={()=>random_toggle('nest')}>
          Reflections from the Nest
        </div>
        { thought==='nest' &&
        <div id='nest' className='RandomThought'>
          I feel like an eaglet peering out of the nest at the open space below.
          Tentatively stretching my wings, preparing for the day I try my first
          soar. I was blessed for 18 years in sharing a home with a truly
          spiritual man. Like the father eagle, his familiarity with the high
          places enabled him to watch over and protect the nest. But now he as
          soared to new heights to be with the Father of all Eagles. Now it is
          my turn to try my wings. Will I too, someday, be able to soar to those
          heights of majesty? Maybe, for the father eagle taught me well. It
          will be enough, though, just to fly the straight and narrow as best I
          can. For if I do, I will myself finally ride the rising thermal to
          find the nest of the Father of all Eagles.
          <br />
          <br />
          <a
            href='http://www.harvestermission.org/aboutdavid.html'
            target='_blank' rel='noreferrer'>
            The Father Eagle
          </a>
        </div>
}
      </div>
    </div>
  );
}
